import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import {
    TextField,
    DatePicker,
} from "react-md";
import moment from 'moment';
import calendar from '../../../assets/images/search-result/calendar.svg';
import {CREATE, DATE_FORMAT, EDIT, SEARCH_BAR, SEARCH_BAR_DATE_PLACEHOLDER} from './../constants';
import { CALENDER_DATE_FORMAT, CALENDER_DISPLAY_DATE_FORMAT, DATE_PICKER_DATE_FORMAT } from '../../../settings';
import { getDatesBetween } from './../../../helper/RangePickerHelper';
import blueTick from '../../../assets/images/common/blueTick.svg';
import greenTick from '../../../assets/images/common/okGreen.svg';
import { push } from 'connected-react-router';
import { updateURLParameter } from '../../SpaceListing/Common/Common';

const RangePicker = ({ setSelectedDate, selectedDate, index, handleDateChange, dateString, setDuration, availableDates, formFrom, blockType=CREATE, setPreviousDates, label, className="date-select", calendarIcon , okIcon, bookingFlow= false, urlStartDate, urlEndDate, urlUpdate=true}) => {
    const dispatch = useDispatch();
    const [eventDate, setEventDate] = useState();
    const isEventDate = eventDate ? (date) => (
        date.getFullYear() === endDate.getFullYear()
        && date.getMonth() === endDate.getMonth()
        && date.getDate() == endDate.getDate()) : null;

    const [visible, setVisible] = useState(false);
    const locationPath = useSelector((state) => state?.router?.location?.pathname || '');
    const searchURLString = useSelector((state) => state?.router?.location?.search || "");
    const [verified, setVerify] = useState(false);
    //to style the selected date classes
    const getDateClassName = (date) => {

        const available = availableDates.find(availDate => {
            const [ checkingDate ] = Object.keys(availDate);
            if(availDate[`${moment(date).format(DATE_FORMAT)}T00:00:00.000+0000`] &&
                `${moment(date).format(DATE_FORMAT)}T00:00:00.000+0000` === checkingDate )
                return availDate[checkingDate];
        });

        const beginRange = moment(date).isSame(moment(startDate && startDate));
        const endRange = moment(date).isSame(moment(endDate && endDate));
        const between = moment(date).isBetween(moment(startDate), moment(endDate));
        const startEndDateIsSame = moment(startDate).isSame(moment(endDate));

        if (beginRange) {
            if(available && !available[`${moment(date).format(DATE_FORMAT)}T00:00:00.000+0000`].status){
                return startEndDateIsSame ? '':'day-with-events ' + 'start-range-date disable-current-date-btn';
            }else {
                return startEndDateIsSame ? '':'day-with-events ' +  'start-range-date ';
            }
        } else if (endRange) {
            return 'day-with-events end-range-date';
        } else if (between) {
            return 'day-with-events';
        }
        return null;
    };
    let dates = [];
    let prevSelectedDate = null;
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    
    // Helper function to validate and parse dates
    const parseUrlDate = (dateString) => {
        if (!dateString || dateString === 'Invalid date' || dateString === 'Invalid%20date') {
            return null;
        }
        const parsedDate = moment(dateString, CALENDER_DISPLAY_DATE_FORMAT);
        return parsedDate.isValid() ? parsedDate.toDate() : null;
    };
    
    useEffect(() => {
        if (selectedDate.length > 0) {
            let flatArray = [].concat(...selectedDate);
            prevSelectedDate = flatArray[flatArray.length - 1];
        }
    }, [])
    useEffect(() => {
        if(urlStartDate || urlEndDate){
            const parsedStartDate = parseUrlDate(urlStartDate);
            const parsedEndDate = parseUrlDate(urlEndDate);
            
            // Only set dates if they are valid
            if(parsedStartDate) {
                setStartDate(parsedStartDate);
                if(parsedEndDate) {
                    setEndDate(parsedEndDate);
                } else {
                    setEndDate(parsedStartDate);
                }
                dateRenderer();
            }
        } else {
            if(formFrom === 'EDIT_RESERVATION' && selectedDate && selectedDate.length > 0){
                const [ selctedDateArray ] = selectedDate;
                if(selctedDateArray && selctedDateArray.length > 0){
                    setStartDate(typeof selctedDateArray === 'string'  ? moment().toDate() : moment(selctedDateArray[0], DATE_PICKER_DATE_FORMAT).toDate());
                    setEndDate(typeof selctedDateArray === 'string' ? moment().toDate() : moment(selctedDateArray[selctedDateArray.length-1], DATE_PICKER_DATE_FORMAT).toDate());
                    dateRenderer();
                }
            } else {
                if(bookingFlow && selectedDate && selectedDate.length > 0){
                    setStartDate(moment(selectedDate[0], DATE_PICKER_DATE_FORMAT).toDate());
                    setEndDate(moment(selectedDate[0], DATE_PICKER_DATE_FORMAT).toDate());
                    dateRenderer();
                }
            }

        }

    }, [selectedDate, urlEndDate, urlStartDate])

    const isValidRange = (selectedDateRange) => {
        let selectedValidation = true;
        if (availableDates && availableDates.length >0 && selectedDateRange.length > 0) {
            selectedDateRange.forEach(selected => {
                const available = availableDates.find(availDate => {
                    const [ checkingDate ] = Object.keys(availDate);
                    if(availDate[`${moment(selected).format(DATE_FORMAT)}T00:00:00.000+0000`] &&
                        `${moment(selected).format(DATE_FORMAT)}T00:00:00.000+0000` === checkingDate )
                        return availDate[checkingDate];
                });
                if(available && !available[`${moment(selected).format(DATE_FORMAT)}T00:00:00.000+0000`].status){
                    selectedValidation = false;
                }
            });
        }
        return selectedValidation;
    }

    const handleDateClick = (date) => {
        if (!startDate) {
            setStartDate(date);
            setEndDate(date)
        } else if (moment(date).isBefore(startDate)) {
            setStartDate(date);
        } else if (moment(date).isAfter(endDate)) {
            setEndDate(date);
        } else if (moment(date).isSame(endDate) || moment(date).isSame(startDate)) {
            setStartDate(date);
            setEndDate(date);
        } else {
            setEndDate(date);
        }
    }

    const handleClearAll = () => {
        if(blockType === EDIT){
            setPreviousDates();
            setVisible(false);
        }else if(blockType === SEARCH_BAR){
            setStartDate();
            setEndDate();
            setSelectedDate([])
            handleDateChange(index, SEARCH_BAR_DATE_PLACEHOLDER)
            setVisible(false);
        }else{
            setStartDate();
            setEndDate();
            setSelectedDate([])
            setVisible(false);
        }
    }

    useEffect(() => {
        handleDateChange(index, `${moment(startDate).format('L')} - ${moment(endDate).format("L")}`)
    }, [startDate, endDate])

    const handleOk = () => {
        if (startDate) {
            dates = getDatesBetween(startDate, endDate);
            if(urlUpdate){
                dispatch(push(updateURLParameter(updateURLParameter(searchURLString, 'urlStartDate', moment(startDate).format(CALENDER_DATE_FORMAT)), 'urlEndDate', moment(endDate).format(CALENDER_DATE_FORMAT))));
            }
        }
        if (dates.length !== 0) {
            let prevState = selectedDate
            prevState.splice(index, 1, dates)
            if(isValidRange(prevState[index])){
                setSelectedDate(prevState);
                setVisible(false);
                setDuration(dates.length);
            }else{
                setStartDate();
                setEndDate();
                setSelectedDate([])
                dateRenderer();
            }
        }
    }

    const dateRenderer = (date, day) => {

        const available = availableDates.find(availDate => {
            const [ checkingDate ] = Object.keys(availDate);
            if(availDate[`${moment(date).format(DATE_FORMAT)}T00:00:00.000+0000`] &&
                `${moment(date).format(DATE_FORMAT)}T00:00:00.000+0000` === checkingDate )
                return availDate[checkingDate];
        });

        if(!available){
            if(moment(date).format(DATE_FORMAT) === moment().format(DATE_FORMAT)){
                return <span className="normal-date-cls disable-date-cls current-date" disabled>{day}</span>
            } else {
                return <span className="normal-date-cls disable-date-cls " disabled>{day}</span>
            }
        }

        if(available && !available[`${moment(date).format(DATE_FORMAT)}T00:00:00.000+0000`].status){
            if(moment(date).format(DATE_FORMAT) === moment().format(DATE_FORMAT)){
                return <span className="normal-date-cls disable-date-cls current-date" disabled>{day}</span>
            } else {
                return <span className="normal-date-cls disable-date-cls " disabled>{day}</span>
            }
        }


        if (moment(date).format("L") == moment().format("L")) {
            return <span className="normal-date-cls current-date" onClick={() => handleDateClick(date)}>{day}</span>
        }
        if (startDate && moment(date).isBetween(moment(startDate), moment(endDate))
            || moment(date).isSame(startDate)
            || moment(date).isSame(endDate)) {
            return <span className="normal-date-cls calendar-select-days" onClick={() => handleDateClick(date)} >{day}</span>;

        } if (startDate && moment(date).isSame(moment(startDate))
            || moment(date).isSame(startDate)
            || moment(date).isSame(endDate)) {
            return <span className="normal-date-cls end-date" onClick={() => handleDateClick(date)} >{day}</span>;
        } if (endDate && moment(date).isSame(moment(endDate))
            || moment(date).isSame(startDate)
            || moment(date).isSame(endDate)) {
            return <span className="normal-date-cls start-date" onClick={() => handleDateClick(date)} >{day}</span>;

        } else if (moment(date).isBefore(moment())) {
            return <span className="normal-date-cls disable-date-cls" disabled>{day}</span>

        } else
            return <span className="normal-date-cls" onClick={() => handleDateClick(date)}>{day}</span>;

    };

    useEffect(() => {
        if (locationPath?.includes('/dashboard')) {
            setVerify(true);
        }
    }, [locationPath]);

    const getDateString = () => {
        const dates = dateString.replace(/ /g,'').split('-');
        return moment(dates[0], DATE_PICKER_DATE_FORMAT).format('DD MMM YYYY') + " - "+ moment(dates[1], DATE_PICKER_DATE_FORMAT).format('DD MMM YYYY');;
    }

    return (
        <div className="date-block" key={index}>
            <TextField
                onClick={() => setVisible(!visible)}
                className={className}
                id={`text-field-type-number`}
                placeholder="Placeholder"
                leftIcon={<img src={calendarIcon || calendar} className="img" alt="calendar" />}
                value={getDateString()}
                label={label}
            />
            <DatePicker
                defaultValue={startDate}
                value={startDate}
                id="inline-date-picker-portait"
                className="booking-range-picker guest-input"
                placeholder="Select a date"
                inline
                visible={visible}
                displayMode={"portrait"}
                fullWidth={false}
                dateRenderer={dateRenderer}
                getDateClassName={getDateClassName}
                onChange={handleOk}
                cancelLabel={<span className="clear-all-btn" onClick={() => handleClearAll()}>Clear</span>}
                okLabel={verified? <img src={greenTick} className="img" alt="calendar" />: blueTick ? <img src={blueTick} className="img" alt="calendar" /> : 'Ok'}
            />
        </div>
    );
};

RangePicker.propTypes = {
    setSelectedDate: PropTypes.string,
    selectedDate: PropTypes.array,
    handleDateChange: PropTypes.func,
    dateString: PropTypes.string,
}

export default RangePicker;
